const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Zoom settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {CompanyIntegrations} CompanyIntegrations injected to gain access to the Company Integrations
 */
app.directive('zoomSettings', ['Application', 'CompanyIntegrations', 'ZoomIntegrate', function (Application, CompanyIntegrations, ZoomIntegrate) {
  return {
    restrict: "E",
    replace: true,
    scope : {
    },
    template: require('../../templates/directives/zoom-settings.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.zoomLink = Application.zoomLink;
      self.allowAI = Application.features.flags().enable_generative_ai;

      self.checkParams = function() {
        var params = Application.navigation.getUrlParameters();
        if (params.zoomcode) {
          ZoomIntegrate.create({}, {
            code: params.zoomcode,
            // Signed CSRF state minted by the API, relayed back through Zoom and
            // the API's centralized OAuth relay; the API validates it when
            // present and derives the token-exchange redirect_uri server-side.
            state: params.state
          }, function(data) {
            self.hasZoom = true;
            Application.messaging.addMessage({type: 'success', duration: 3, text: 'Zoom integration successful!'});
            Application.navigation.goTo('/overview/settings/integrations', {});
          }, function(err) {
            console.log('error in making zoom integration: ', err);
            Application.navigation.goTo('/overview/settings/integrations', {});
          });
        } else if (params.error) {
          // Consent denial forwarded by the API relay (user canceled on
          // Zoom's consent screen) — there is no code to exchange. The toast
          // template renders via ng-bind-html, so only echo the error when it
          // looks like an OAuth error code, not arbitrary URL input.
          var zoomError = /^[\w.-]+$/.test(params.error) ? ' (' + params.error + ')' : '';
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'Zoom authorization was canceled' + zoomError + '.'});
        }

      };
      
      self.initialize = function () {

        CompanyIntegrations.status({}, function (data) {
          self.companyIntegration = data || {};
          self.hasZoom = data.zoom || false;
          self.needsUpdate = data.zoomNeedsAIUpdate || false;

          self.checkParams();
        }, function (error) {
          console.log('Error occured getting company integration ', error);
        });

      };
      self.initialize();
    }],
    controllerAs: 'zoom'
  };
}]);
